var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "energy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.135,
    height: 74.135,
    viewBox: "0 0 74.135 74.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_519",
    "data-name": "Caminho 519",
    d: "M75.035,37.967A37.068,37.068,0,1,1,37.784.9,37.119,37.119,0,0,1,75.035,37.967ZM37.906,72.907A34.939,34.939,0,1,0,3.028,38.136,34.926,34.926,0,0,0,37.906,72.907Z",
    transform: "translate(-0.9 -0.9)",
    fill: "#cb8f55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_520",
    "data-name": "Caminho 520",
    d: "M143.724,120.508c-2.649-.567-5.19-1.1-7.732-1.638-1.546-.322-3.108-.6-4.639-1a1.754,1.754,0,0,1-1.118-.827,1.5,1.5,0,0,1,.459-1.24q11.851-12.218,23.762-24.405c.459-.475.949-.827,1.608-.413s.521,1.026.276,1.638l-6.017,14.882c-.122.306-.245.612-.4,1.011,1.531.245,3,.475,4.471.689,3.093.475,6.2.919,9.294,1.424a1.663,1.663,0,0,1,1.041.75c.276.505-.077.949-.475,1.332q-6.362,6.178-12.723,12.371-5.971,5.81-11.958,11.636c-.107.107-.214.214-.337.322a1.046,1.046,0,0,1-1.393.2,1.033,1.033,0,0,1-.352-1.409l2.251-5.512c1.225-2.986,2.45-5.987,3.675-8.972C143.525,121.089,143.6,120.844,143.724,120.508Zm-2.251,11.208c.046.031.077.046.122.077,6.6-6.415,13.183-12.83,19.858-19.338-.352-.077-.551-.138-.75-.168l-12.019-1.837c-1.271-.2-1.562-.7-1.087-1.883q2.2-5.489,4.44-10.978c.107-.276.2-.551.306-.842l-.092-.046c-6.277,6.446-12.57,12.892-18.94,19.414.291.077.413.107.536.138,3.721.781,7.426,1.562,11.146,2.343,1.255.26,1.516.781,1.026,1.975-1.225,3-2.45,5.987-3.675,8.987C142.055,130.261,141.764,131,141.473,131.715Z",
    transform: "translate(-110.408 -77.04)",
    fill: "#cb8f55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.50d139cfc4d6163af344668a8bfd1aa9.svg";
export { ForwardRef as ReactComponent };